import { useContext, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { useNavigate, useParams } from "react-router-dom";
import { toast, haveValue } from "../../../helper/common";
import {
  Button,
  Card,
  Icon,
  Tabs,
  TextField,
} from "../../../components/design";
import "./idealistaImport.css";

const AddIdealistaProperty = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { bringPropertiesKelify } = useContext(LandLordContext);
  const [username, setUsername] = useState("");
  const [bringPropertiesLoading, setBringPropertiesLoading] = useState(false);

  const handleBringProperty = async (e) => {
    e.preventDefault();
    try {
      setBringPropertiesLoading(true);
      const payload = {
        username_url: username,
      };
      const res = await bringPropertiesKelify(payload);
      if (res.status === "success") {
        setUsername("");
        toast.success(res?.imported + " " + _t("propertiesImported"));
        navigate(haveValue(workspaceId) ? `/${workspaceId}/home` : `/home`);
      } else {
        toast.error(
          res?.response?.data?.message ?? _t("failedToImportProperties")
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ?? _t("failedToImportProperties")
      );
    } finally {
      setBringPropertiesLoading(false);
    }
  };
  const [activeTab, setActiveTab] = useState("url");

  const steps = [
    _t("idealistaStepOne"),
    _t("idealistaStepTwo"),
    _t("idealistaStepThree"),
  ];

  return (
    <div className="idealista-import">
      <div className="idealista-import__layout">
        <section className="idealista-import__intro">
          <h1>{_t("addPropertiesAndGetStarted")}</h1>
          <p className="idealista-import__lead">
            {_t("noPropertiesHasBeenAddedyet")}
          </p>

          <h2 className="idealista-import__eyebrow">
            {_t("idealistaHowItWorks")}
          </h2>
          <ol className="idealista-import__steps">
            {steps.map((step, index) => (
              <li key={index}>
                <span className="idealista-import__step-number">
                  {index + 1}
                </span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </section>

        <Card className="idealista-import__card">
          <form
            onSubmit={handleBringProperty}
            className="idealista-import__form"
          >
            <div className="idealista-import__brand">
              <img src="/images/idealista-icon.svg" alt="" />
              <div>
                <h2>{_t("bringYourPropertyFromIdealista")}</h2>
                <p>{_t("idealistaCardSubtitle")}</p>
              </div>
            </div>
            <Tabs
              block
              value={activeTab}
              onChange={setActiveTab}
              items={[
                {
                  value: "url",
                  label: _t("importByUrl"),
                  icon: <Icon name="link" size={16} />,
                },
                {
                  value: "agency",
                  label: _t("importByAgency"),
                  icon: <Icon name="building" size={16} />,
                },
              ]}
            />
            <TextField
              id="idealista-username"
              name="email"
              label={
                activeTab === "url" ? _t("usernameOrUrl") : _t("agencyName")
              }
              placeholder={
                activeTab === "url"
                  ? _t("enterUsernameOrURL")
                  : _t("enterAgencyName")
              }
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Button
              type="submit"
              size="lg"
              block
              loading={bringPropertiesLoading}
            >
              {bringPropertiesLoading
                ? _t("importingProperties")
                : _t("bringProperty")}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default AddIdealistaProperty;
